/*=========================================================================================
	File Name: moduleAuthMutations.js
	Description: Auth Module Mutations
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
	STOCK_LIST(state, value) {
		state.Stock = value; 

	}, STOCK_BARCODES_LIST(state, value) {
		state.StockBarcodes = value
	},
	
	ADD_ITEM_STOCK(state, item) {
		const output = Object.entries(item).map(([key, value]) => [
			key[0].toUpperCase() + key.slice(1), value,]);
		state.Stock.push(Object.assign({}, Object.fromEntries(output)))
	},
	DELETE_ITEM_STOCK(state, item) {
		const index = state.Stock.findIndex(i => i.StockId === item)
		if (index > -1) { state.Stock.splice(index, 1) }
	}
}
